import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const MarkdownParser = ({ content }) => {
  // 🔥 Fix: Ensure `content` is a valid string to avoid errors
  const safeContent = typeof content === "string" ? content : "**(No content available)**";

  // Custom components for ReactMarkdown
  const components = {
    img: ({ src, alt, ...props }) => {
      // Ensure image src is properly resolved from public folder
      const imageSrc = src.startsWith('/') ? src : `/${src}`;
      return (
        <img 
          src={imageSrc} 
          alt={alt} 
          {...props}
          style={{ 
            maxWidth: 'min(600px, 90vw)', // Responsive to viewport width
            width: '100%', 
            height: 'auto',
            margin: '1rem auto',
            display: 'block'
          }}
          className="blog-image"
        />
      );
    },
    p: ({ children, ...props }) => {
      return (
        <p {...props} style={{ 
          marginBottom: '1.25rem', 
          lineHeight: '1.7',
          fontSize: '0.95rem'
        }}>
          {children}
        </p>
      );
    },
    h2: ({ children, ...props }) => {
      return (
        <h2 {...props} style={{ 
          marginTop: '2rem', 
          marginBottom: '0.5rem',
          fontSize: '1.2rem',
          fontWeight: '500'
        }}>
          {children}
        </h2>
      );
    }
  };

  return (
    <ReactMarkdown 
      className="prose max-w-none" 
      remarkPlugins={[remarkGfm]}
      components={components}
    >
      {safeContent}
    </ReactMarkdown>
  );
};

export default MarkdownParser;

